module.exports = __webpack_public_path__ + "img/164.shop.b03c4e4e.svg";